(function(InlineCart, $, undefined) {

  // Private
  var lineItemEntryPoint = $('[data-cart-contents]');
  var shopCartEntryPoint = $('[data-shop-cart]');
  var isShopPage = window.location.pathname === '/collections/all';
  var header = $('[data-header]');

  var getCartContents = function() {
    $.get('/cart?view=ajax', function(response) {
      lineItemEntryPoint.html(response);
    });
  };

  var getShopCartContents = function() {
    $.get('/cart?view=shop', function(response) {
      shopCartEntryPoint.html(response);
    });
  }

  var addLineItem = function(self) {
    var variantId = $(self).attr('data-variant-id');
    var variantTitle = $(self).attr('data-variant-title');
    var variantQty = parseInt($(self).attr('data-variant-quantity'));
    var variantPrice = parseFloat($(self).attr('data-variant-price'));
    var value = variantQty * variantPrice;
    var productId = $(self).attr('data-product-id');
    var productTitle = $(self).attr('data-product-title');

    var lineProperties = {};

    CartJS.addItem(variantId, variantQty, lineProperties, {
      "success": function(data, textStatus, jqXHR) {
        console.log({
          id: productId,
          name: productTitle,
          price: variantPrice,
          quantity: variantQty,
          value: value,
          variantId: variantId,
          variantTitle: variantTitle
        })

        window.optimizely.push(["trackEvent", "add-to-cart"]);

        // TRACK SEGMENT EVENT
        analytics.track('Product Added', {
          id: productId,
          name: productTitle,
          price: variantPrice,
          quantity: variantQty,
          value: value,
          variantId: variantId,
          variantTitle: variantTitle
        });

        // Trigger correct GA funnel
        ga('send', { 'hitType': 'pageview', 'page': '/cart', 'title': 'Added to Cart' });

        if (productId === '2320515843' || productId === '1988450947') {
          CartJS.addItem(5689440387, 1);
          CartJS.addItem(7905522243, 1);
        } else if (productId === '1620954349658' || productId === '1346004942938') {
          CartJS.addItem(17163560878170, 1);
        }

        triggerInlineCart();
      },
      "error": function(jqXHR, textStatus, errorThrown) {
        // Define an error callback to display an error message.
        window.alert('Sorry, we\'re unable to do that.\n' + JSON.parse(jqXHR.responseText).description);
      }
    });
  };

  var removeLineItem = function(e, self) {
    var variantId = $(self).attr('data-variant-id');
    if(e) {e.preventDefault();}
    CartJS.updateItemById(variantId, 0);
  };

  var triggerInlineCart = function(e) {
    if(e) {e.preventDefault();}
    $('body').addClass('cart-open scroll-lock');
  };

  var toggleInlineCart = function(e) {
    if(e) {e.preventDefault();}
    $('body').toggleClass('cart-open scroll-lock');
  };

  var closeInlineCart = function(e) {
    if(e) {e.preventDefault();}
    $('body').removeClass('cart-open scroll-lock');
  };

  function getItemById(variant_id) {
    for (var i = 0; i < CartJS.cart.items.length; i++) {
      var item = CartJS.cart.items[i];

      if (item.id == variant_id) {
        return item;
      }
    }
  }

  function checkIfItems() {
    if (isShopPage) {
      getShopCartContents();
    }
  }

  // Event Bindings
  var bindUIActions = function() {
    $(document).on('click', '[data-cart-close]', closeInlineCart);
    $(document).on('click', '[data-cart-open]', triggerInlineCart);

    $(document).on('click', '[data-add-to-cart]', function() {
      if ($(this).is('[data-disabled]')) {
        console.log('here');
      } else {
        addLineItem(this);
      }
    });

    $(document).on('click', '[data-quantity]', function(e) {
      var max = parseInt($(this).siblings('.qty-control__qty').attr('data-max'));
      var quantity = parseInt($(this).data('quantity'));
      var update = parseInt($(this).data('update'));
      var $message = $(this).closest('.line-item').find('[data-message]');
      if (quantity > max) {
        $message.html('Sorry, max quantity for this item is ' + max + '. Click <a class="text-link" href="/pages/contact-sales">here</a> for wholesale information.');
        return false;
      } else {
        CartJS.updateItem(update, quantity)
      }
    })

    $(document).on('click', '[data-remove-item]', function(e) {      
      removeLineItem(e, this);
    });

    $(document).on('click','[data-toggle-cart]', function(e) {
      toggleInlineCart(e);
      if ($('.hamburger').hasClass('active')) {
        $('.hamburger').removeClass('active');
        $('.site-header__nav').hide();
      }
    });

    $(document).on('click','[data-close-cart]', function(e) {
      closeInlineCart();
    });

    $(document).on('cart.requestStarted', function(event, cart) {
      $('.cart-wrapper').addClass('loading');
      if(window.cartSliderActive) {
        window.currentCartSlide = parseInt($('[data-cart-slider]').slick('slickCurrentSlide'));
      }
    });

    $(document).on('cart.requestComplete', function(event, cart) {
      getCartContents();
      checkIfItems();
      if(CartJS.cart.item_count === 0) {
        setTimeout(function(){ 
          closeInlineCart();
        }, 1000);
      }
    });

    $(document).on('ready', function() {
      if (window.location.hash == '#cart-open') {
        toggleInlineCart();
      }
    })
  };


  // Public
  InlineCart.init = function() {
    bindUIActions();
    getCartContents();
    checkIfItems();
  };

}(window.InlineCart = window.InlineCart || {}, jQuery));